import { C4Form } from './../c4-form';
import { Component, EventEmitter, Input, Output, Optional, Host } from '@angular/core';
import { C4InputSliderFloat } from '../slider-float/c4-input-slider-float';
import { C4InputInterface, C4Input, C4InputConfig } from '../c4-input';

declare var module: any;

@Component({
  selector: 'c4-input-slider-integer',
  templateUrl: 'c4-input-slider-integer.html',
  styles: [`
		.control-label {
			font-weight: normal;
		}
	`],
})
export class C4InputSliderInteger extends C4Input implements C4InputInterface {
  @Input() config;
  @Input() name: string;
  @Input() tagId: string;
  @Input() value: number;

  @Output() valueChange: EventEmitter<number> = new EventEmitter<number>();

  @Input() precision: number;
  @Input() increment: number;
  @Input() stepCount: number;
  @Input() min: number;
  @Input() max: number;

  constructor( @Optional() @Host() form: C4Form) {
    super(form);
  }

  ngOnInit() {
    super.ngOnInit();

    // If increment isn't set already, set it to 1
    this.increment = this.increment || 1;

    // If increment is less than 1, make it 1
    this.increment = (this.increment < 1) ? 1 : this.increment;
  }
}



// WEBPACK FOOTER //
// ./~/@c4/ui/src/app/directives/input/slider-integer/c4-input-slider-integer.ts